module.exports = __webpack_public_path__ + "1d5782531e1a878dcf03e11c5e985228.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/mythos-2.jpg
// module id = 667
// module chunks = 0